/* eslint-disable camelcase */
import { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import CarePlanForm from './CarePlanReviewForm'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'
import { useCarePlanPopulated } from '../../hooks/useCarePlanPopulated'

/**
 * Fetch the data required and initialise the form state to render the CarePlanReviewForm
 */
export const CarePlanReviewScreen = ({
  addForm,
  editCarePlanFormExists,
  removeForm,
  router,
}) => {
  const {
    params: { care_plan_id },
  } = router

  const { data: careplan, isLoading } = useCarePlanPopulated({
    carePlanId: care_plan_id,
  })

  const addFormWithReset = useCallback(
    (plan) => {
      const planCopy = { ...plan }
      if (planCopy.nextReviewDate) planCopy.nextReviewDate = null
      addForm(planCopy)
    },
    [addForm]
  )

  // Add form when careplan becomes available and form doesn't exist
  useEffect(() => {
    if (!editCarePlanFormExists && careplan) {
      addFormWithReset(careplan)
    }
  }, [careplan, editCarePlanFormExists, addFormWithReset])

  // Clean up form when unmounting to ensure fresh data on next visit
  useEffect(() => {
    return () => {
      removeForm()
    }
  }, [removeForm])

  if (isLoading || !careplan) return null

  return <CarePlanForm router={history} params={router.params} />
}

CarePlanReviewScreen.propTypes = {
  addForm: PropTypes.func.isRequired,
  editCarePlanFormExists: PropTypes.bool,
  removeForm: PropTypes.func.isRequired,
  router: PropTypes.object,
}

const mapStateToProps = (state) => ({
  editCarePlanFormExists: !!state.forms.editCarePlan,
})

const mapDispatchToProps = (dispatch) => ({
  addForm: (initial) =>
    dispatch(
      Actions.addForm({
        formId: 'editCarePlan',
        initial,
      })
    ),
  removeForm: () => dispatch(Actions.removeForm('editCarePlan')),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CarePlanReviewScreen))
